import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/ic_ar@2x.png'
import _imports_1 from '@/assets/icon/gongdan_ic_shoudong@2x.png'
import _imports_2 from '@/assets/icon/ic_close@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-59fddafc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = {
  key: 0,
  class: "bg_plan_label"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("工序生产计划")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "bg_plan_nr"
}
const _hoisted_6 = { class: "bg_plan_label_val" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "bg_list" }
const _hoisted_10 = { class: "bg_list_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "生产信息")
  ])
], -1))
const _hoisted_12 = { class: "bg_list_item_h" }
const _hoisted_13 = { class: "bg_list_item_num_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产设备", -1))
const _hoisted_15 = { class: "bg_list_item_num_item_sr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "bg_list_item_num_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产人员", -1))
const _hoisted_19 = { class: "bg_list_item_num_item_sr" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "bg_list_item" }
const _hoisted_22 = { class: "bg_list_item_top" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "生产信息")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增投料", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "bg_list_item_h" }
const _hoisted_28 = { class: "bg_list_item_num" }
const _hoisted_29 = { class: "bg_list_item_num_item" }
const _hoisted_30 = { class: "bg_list_item_num_item_wl" }
const _hoisted_31 = { class: "bg_list_item_num_item_wl_lx" }
const _hoisted_32 = {
  key: 0,
  class: "green"
}
const _hoisted_33 = {
  key: 1,
  class: "yellow"
}
const _hoisted_34 = {
  key: 2,
  class: "red"
}
const _hoisted_35 = { class: "bg_list_item_num_item_sr" }
const _hoisted_36 = ["onUpdate:modelValue", "onInput"]
const _hoisted_37 = {
  key: 1,
  class: "kong"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 2,
  class: "kong"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前工序无需投料", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "bg_list_item bottomval" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "产出明细")
  ])
], -1))
const _hoisted_45 = { class: "bg_list_item_h" }
const _hoisted_46 = { class: "bg_list_item_num" }
const _hoisted_47 = { class: "bg_list_item_num_item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("良品数")
], -1))
const _hoisted_49 = { class: "bg_list_item_num_item_sr" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "bg_list_item_num" }
const _hoisted_52 = { class: "bg_list_item_num_item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良数", -1))
const _hoisted_54 = { class: "bg_list_item_num_item_sr" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 0,
  class: "bg_list_item_num"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("不良项")
], -1))
const _hoisted_58 = { class: "bg_list_item_num_item_sr" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_plan_label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "报工时长")
], -1))
const _hoisted_61 = { class: "bg_plan_label_val" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_63 = {
  key: 0,
  class: "bg_list_item"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "工资绩效")
  ])
], -1))
const _hoisted_65 = { class: "bg_list_item_h" }
const _hoisted_66 = { class: "bg_list_item_num" }
const _hoisted_67 = { class: "bg_list_item_num_item" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计件方式", -1))
const _hoisted_69 = { class: "bg_list_item_num_item_list" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "bg_list_item_num" }
const _hoisted_72 = { class: "bg_list_item_num_item" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工资单价", -1))
const _hoisted_74 = { class: "bg_list_item_num_item_sr" }
const _hoisted_75 = { class: "color1" }
const _hoisted_76 = { class: "bg_list_item_num" }
const _hoisted_77 = { class: "bg_list_item_num_item" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预计工资", -1))
const _hoisted_79 = { class: "bg_list_item_num_item_sr" }
const _hoisted_80 = { class: "color1" }
const _hoisted_81 = { class: "bg_list_item_num" }
const _hoisted_82 = { class: "bg_list_item_num_item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "达标率", -1))
const _hoisted_84 = { class: "bg_list_item_num_item_sr" }
const _hoisted_85 = { class: "color1" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bh_zw" }, null, -1))
const _hoisted_87 = { class: "bl" }
const _hoisted_88 = { class: "bl_head" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"opacity":"0"},
  alt: ""
}, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良项", -1))
const _hoisted_91 = { class: "bl_list" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "bl_list_item_left" }
const _hoisted_94 = ["checked"]
const _hoisted_95 = { class: "bl_list_item_right" }
const _hoisted_96 = ["onUpdate:modelValue"]

import { onMounted, ref, reactive, getCurrentInstance, computed } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from 'vuex'
    import { getDeviceByCondition, getFindAll, queryOne, queryList, autoWorkReport, getIdPlansExt, categoryExtList } from '@/apis/PlanningAPI'
    import MaterialY from '@/components/newCom/MaterialY.vue'
    import user from '@/components/newCom/user.vue'
    import { Toast } from 'vant'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const {$Bus} = getCurrentInstance().appContext.config.globalProperties 
    const router = useRouter()
    const store = useStore()
    let show = ref(false)
    let show1 = ref(false)
    let TimeShow = ref(false)
    let deviceId = ref('')
    let plansId = ref('')
    let ids = ref('')
    let total: any = ref('')    // 可投数量

    let from: any = reactive({
        processPlan: null,
        deviceId: '',
        deviceName: '',
        userId: store.state.userInfo.id,
        userName: store.state.userInfo.companyUser.name,
        qualified: '',  // 良品数
        undesirable: '', // 不良数
        duration: '',
        durationName: '0小时0分钟',
        time: '',
        defective: [],
        defectiveName: '',
        type: '',    // 绩效类型
        index: 0
    })

    // { name: '计件', active: false, id: 0 }, { name: '计时', active: false, id: 1 } 
    let arrType: any = ref([])

    let infoBox: any = ref(null)     // 工资绩效

    let bomType: any = ref('')
    let hasBom: any = ref('')
    let deviceShow = ref(false)
    let deviceList = ref([])
    let cateList:any = ref([])
    const customFieldName = {
        text: 'name'
    };
    let userShow = ref(false)
    let wuList = ref<Array<any>>([])

    const openBL = () => {
        cateList.value.forEach((item: any) => {
            if (!item.active) {
                item.num = ''
            }
            if (item.active && item.num <= 0) {
                item.active = false
            }
        })
        show.value = true
    }

    // 切换绩效类型
    const clickPerformanceType = (i: number) => {
        from.index = i
        arrType.value.forEach((item: any, index: number) => {
            if (i === index) {
                from.type = item.id
            }
            item.active = index === i
        })
    }

    // 产出数量验证
    const changeNum = (type: number) => {
        let num = total.value - (Number(from.qualified) + Number(from.undesirable))
        if (type == 2) {
            from.defective = []
            from.defectiveName = ''
        }
        if (num < 0) {
            Toast('产出数量不能大于可产出数量！')
            if (type == 1) {
                from.qualified = ''
            } else {
                from.undesirable = ''
            }
        }
    }

    // 验证物料数量
    const inputwl = (i: number) => {
        if (wuList.value[i].num > wuList.value[i].total) {
            wuList.value[i].num = ''
            Toast('投料数量不能大于库存数量')
        }
    }

    const changeChecked = (i: number) => {
        cateList.value[i].active = !cateList.value[i].active
    }

    const onConfirm3 = () => {
        let isOpen = false
        cateList.value.forEach((item: any, index: number) => {
            if (item.active) {
                isOpen = true
            }
        })
        if (!isOpen) return Toast('请选择不良项')
        let arr: any = []
        let total: any = 0
        let name: any = ''
        for (let i = 0; i < cateList.value.length; i++) {
            if (cateList.value[i].active) {
                if (cateList.value[i].num <= 0) {
                    return Toast('不良数量必须大于0')
                }
                total = total += cateList.value[i].num
                arr.push(cateList.value[i])
                name += cateList.value[i].name + cateList.value[i].num + '；'
            }
        }
        // cateList.value.forEach((item: any, index: number) => {
        //     if (item.active) {
        //         if (item.num <= 0) {
        //             return Toast('不良数量必须大于0')
        //         }
        //         total = total += item.num
        //         arr.push(item)
        //         name += item.name + item.num + '；'
        //     }
        // })
        if (total !== from.undesirable) return Toast('不良数必须等于产出不良数')
        from.defective = arr
        from.defectiveName = name
        show.value = false
    }

    const continueSubmit = () => {
        if (!from.processPlan) return Toast('计划不能为空')
        if (!from.deviceId) return Toast('设备不能为空')
        if (!from.userId) return Toast('生产人员不能为空')
        if (hasBom.value == 1 && bomType.value == 1) {
            console.log('不需要投料')
        } else {
            if (!wuList.value.length === 0) return Toast('投料不能为空')
        }
        if (!from.qualified && !from.undesirable) {
            return Toast('良品数与不良数不能同时为空')
        }
        // if (!from.qualified) return Toast('良品数不能为空')
        // 有不良数
        if (from.undesirable > 0) {
            if (from.defective.length === 0) return Toast('不良项不能为空')
        }
        // if (!from.duration) return Toast('报工时长不能为空')
        let type = ''
        arrType.value.forEach((item: any) => {
            if (item.active) {
                type = item.id
            }
        })
        autoWorkReport({
            createWorkorderRecordDTO: {
                type,
                duration: from.duration,
                qualifiedNum: from.qualified ? from.qualified : 0,
                unQualifiedNum: from.undesirable ? from.undesirable : 0
            },
            plansId: from.processPlan.id,
            proGroupId: deviceId.value,
            proUserList: [from.userId],
            recordList: wuList.value.map((item: any) => {
                return {
                    wstockId: item.id,
                    num: item.num
                }
            }),
            createUnqualifiedDTOList: from.defective.map((item: any) => {
                return {
                    categoryId: item.id,
                    unQualifiedNum: item.num
                }
            })
        }).then(res => {
            if (res.code === 200) {
                Toast.success({message: '报工成功！'})
                from.processPlan = null
                from.deviceId = ''
                from.deviceName = ''
                from.userId = ''
                from.userName = ''
                from.qualified = ''
                from.undesirable = ''
                from.duration = ''
                from.durationName = '0小时0分钟'
                from.time = ''
                from.defective = []
                from.defectiveName = ''
                wuList.value = []
                deviceId.value = ''
                plansId.value = ''
                ids.value = ''
                total.value = ''
            }
        })
    }

    const submit = () => {
        if (!from.processPlan) return Toast('计划不能为空')
        if (!from.deviceId) return Toast('设备不能为空')
        if (!from.userId) return Toast('生产人员不能为空')
        if (hasBom.value == 1 && bomType.value == 1) {
            console.log('不需要投料')
        } else {
            if (!wuList.value.length === 0) return Toast('投料不能为空')
        }
        if (!from.qualified && !from.undesirable) {
            return Toast('良品数与不良数不能同时为空')
        }
        // if (!from.qualified) return Toast('良品数不能为空')
        // 有不良数
        if (from.undesirable > 0) {
            if (from.defective.length === 0) return Toast('不良项不能为空')
        }
        // if (!from.duration) return Toast('报工时长不能为空')
        let type = ''
        arrType.value.forEach((item: any) => {
            if (item.active) {
                type = item.id
            }
        })
        autoWorkReport({
            createWorkorderRecordDTO: {
                type,
                duration: from.duration,
                qualifiedNum: from.qualified ? from.qualified : 0,
                unQualifiedNum: from.undesirable ? from.undesirable : 0
            },
            plansId: from.processPlan.id,
            proGroupId: deviceId.value,
            proUserList: [from.userId],
            recordList: wuList.value.map((item: any) => {
                return {
                    wstockId: item.id,
                    num: item.num
                }
            }),
            createUnqualifiedDTOList: from.defective.map((item: any) => {
                return {
                    categoryId: item.id,
                    unQualifiedNum: item.num
                }
            })
        }).then(res => {
            if (res.code === 200) {
                Toast.success({message: '报工成功！'})
                setTimeout(() => {
                    router.go(-1)
                }, 2000);
            }
        })
    }

    // 预计工资
    const expectedSalary = computed(() => {
        if (arrType.value.length === 0) return 0;
        if (arrType.value[from.index].type == 0) {
            if (!from.qualified) return 0
            if (arrType.value[from.index].unqualified == 1) {   // 是否计入不良品
                let total = Number(from.qualified) + Number(from.undesirable)
                return (total * (arrType.value[from.index].salary / 10 / 10)).toFixed(2)
            } else {
                return (Number(from.qualified) * (arrType.value[from.index].salary / 10 / 10)).toFixed(2)
            }
        } else {
            if (!from.duration) return 0;
            let h = (from.duration / 60 / 60).toFixed(2)
            return (Number(h) * (arrType.value[from.index].salary / 10 / 10)).toFixed(2)
        }
        // if (!infoBox.value) return 0;
        // 按件计算
        // if (infoBox.value.type == 0) {
        //     if (!from.qualified) return 0
        //     if (infoBox.value.unqualified == 1) {   // 是否计入不良品
        //         let total = Number(from.qualified) + Number(from.undesirable)
        //         return (total * (infoBox.value.salary / 10 / 10)).toFixed(2)
        //     } else {
        //         return (Number(from.qualified) * (infoBox.value.salary / 10 / 10)).toFixed(2)
        //     }
        // } else {
        //     if (!from.duration) return 0;
        //     let h = (from.duration / 60 / 60).toFixed(2)
        //     return (Number(h) * (infoBox.value.salary / 10 / 10)).toFixed(2)
        // }
    })

    // 达标率
    const complianceRate = computed(() => {
        if (arrType.value.length === 0) return 0;
        if (!from.qualified && !from.undesirable) return 0;
        if (!from.duration) return 0;
        if (!arrType.value[from.index].num) return 0;
        // 按件计算
        // if (infoBox.value.type == 0) {
            if (arrType.value[from.index].unqualified == 1) {   // 是否计入不良品
                let a = ((Number(from.qualified) + Number(from.undesirable)) / (from.duration / 3600)).toFixed(2)
                let b = (arrType.value[from.index].num / (arrType.value[from.index].times / 3600)).toFixed(2)
                console.log(a)
                console.log(b)
                return ((Number(a) / Number(b)) * 100).toFixed(2)
                // let total = (Number(from.qualified) + Number(from.undesirable)) / ((from.duration * 60 * 60) * infoBox.value.num / )
                // return total * infoBox.value.salary;
            } else {
                let a = (from.qualified / (from.duration / 3600)).toFixed(2)
                let b = (arrType.value[from.index].num / (arrType.value[from.index].times / 3600)).toFixed(2)
                console.log(a)
                console.log(b)
                return ((Number(a) / Number(b)) * 100).toFixed(2)
                // return Number(from.qualified) * infoBox.value.salary;
            }

        // if (!infoBox.value) return 0;
        // if (!from.qualified && !from.undesirable) return 0;
        // if (!from.duration) return 0;
        // if (!infoBox.value.num) return 0;
        // // 按件计算
        // // if (infoBox.value.type == 0) {
        //     if (infoBox.value.unqualified == 1) {   // 是否计入不良品
        //         let a = ((Number(from.qualified) + Number(from.undesirable)) / (from.duration / 3600)).toFixed(2)
        //         let b = (infoBox.value.num / (infoBox.value.times / 3600)).toFixed(2)
        //         console.log(a)
        //         console.log(b)
        //         return ((Number(a) / Number(b)) * 100).toFixed(2)
        //         // let total = (Number(from.qualified) + Number(from.undesirable)) / ((from.duration * 60 * 60) * infoBox.value.num / )
        //         // return total * infoBox.value.salary;
        //     } else {
        //         let a = (from.qualified / (from.duration / 3600)).toFixed(2)
        //         let b = (infoBox.value.num / (infoBox.value.times / 3600)).toFixed(2)
        //         console.log(a)
        //         console.log(b)
        //         return ((Number(a) / Number(b)) * 100).toFixed(2)
        //         // return Number(from.qualified) * infoBox.value.salary;
        //     }
        // } else {
        //     console.log('按时长')
        // }
    })

    const deleItem = (index: number) => {
        if (wuList.value.length === 1) return Toast('至少保留一项内容')
        wuList.value.splice(index, 1)
    }
    const openDev = () => {
        if (!from.processPlan) return Toast('请先选择工序生产计划')
        deviceShow.value = true
    }
    const openMaterial = () => {
        if (!plansId.value) return Toast('请先选择工序生产计划')
        if (!deviceId.value) return Toast('请先选择生产设备')
        show1.value = true
    }
    const onConfirm1 = (e: any) => {
        from.userId = e.userId
        from.userName = e.name
        userShow.value = false
    }
    const onConfirm2 = (e: string) => {
        let h = Number(e.substring(0, 2))
        let m = Number(e.substring(3, 5))
        let s = 0
        if (h > 0) {
            s += h * 60 * 60
        }
        if (m > 0) {
            s += m * 60
        }
        from.duration = s
        from.durationName = `${h}小时${m}分钟`
        TimeShow.value = false
    }
    const onCancel1 = () => {
        userShow.value = false
    }
    const onCancel2 = () => {
        TimeShow.value = false
    }
    const onConfirm = (e: any) => {
        from.deviceId = e.id
        from.deviceName = e.name
        deviceId.value = e.id
        from.userId = ''
        from.userName = ''
        // getFindAll({
        //     deviceId: e.id,
        //     planId: from.processPlan.id
        // }).then(res => {
        //     if (res.code === 200) {
        //         res.data.forEach((item: any) => {
        //             item.name = item.umodel.name + '-' + item.tmodel.name
        //         })
        //         userList.value = res.data
        //     }
        // })
        deviceShow.value = false
    }
    const onCancel = () => {
        deviceShow.value = false
    }

    const selectPlan = () => {
        router.push({ name: 'processPlans' })
    }

    const close = () => {
        show1.value = false
    }
    const getData = () => {
        categoryExtList({
            cateType: "3"
        }).then(res => {
            if (res.code === 200) {
                res.data.forEach((item: any) => {
                    item.active = false
                    item.num = ''
                })
                cateList.value = res.data
            }
        })
    }
    // 选择物料
    const getValue = (val: any) => {
        let obj = JSON.parse(JSON.stringify(val))
        obj.total = val.num
        wuList.value.unshift(obj)
        let arr = wuList.value.map((item: any) => item.id)
        ids.value = arr.join(',')
        show1.value = false
    }

    onMounted(() => {
        getData()
        $Bus.on('callback', (res: any)=>{
            from.processPlan = res
            plansId.value = res.id
            from.deviceId = ''
            from.deviceName = ''
            deviceId.value = ''
            // from.userId = ''
            // from.userName = ''
            total.value = res.num - res.workorderDistributNum
            // 获取设备
            getDeviceByCondition({ procedureId: res.procedureId })
                .then(res1 => {
                    if (res1.code === 200) {
                        deviceId.value = res1.data[0].id
                        from.deviceId = res1.data[0].id
                        from.deviceName = res1.data[0].name
                        deviceList.value = res1.data
                    }
                })
            // 获取类型
            getIdPlansExt(res.id)
                .then(res2 => {
                    if (res2.code === 200) {
                        bomType.value = res2.data.bomType
                        hasBom.value = res2.data.hasBom
                    }
                })
            // 获取工资绩效数据
            queryList({
                deleted: 0,
                departId: res.factoryId,
                materialId: res.materialId,
                procedureId: res.procedureId
            }).then(result => {
                if (result.code === 200) {
                    if (result.data && result.data.length > 0) {
                        result.data.forEach((item: any, index: number) => {
                            item.name = item.type == 0 ? '计件' : '计时'
                            item.id = item.type
                            item.active = index == 0
                        })
                        arrType.value = result.data
                    } else {
                        arrType.value = []
                    }
                    // infoBox.value = result.data
                }
            })
        })
    })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg_plan",
      onClick: selectPlan
    }, [
      (!_unref(from).processPlan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(from).processPlan.materialName) + " | " + _toDisplayString(_unref(from).processPlan.materialCode) + " | " + _toDisplayString(_unref(from).processPlan.produceName), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(from).processPlan.batch) + _toDisplayString(_unref(from).processPlan.salesOrder ? ` / ${_unref(from).processPlan.salesOrder}` : ''), 1),
            _createElementVNode("span", null, "计划时间：" + _toDisplayString(_unref(from).processPlan.workPlanStartDate) + " ~ " + _toDisplayString(_unref(from).processPlan.workPlanEndDate), 1),
            _createElementVNode("span", null, "计划进度：" + _toDisplayString(_unref(from).processPlan.num) + "/" + _toDisplayString(_unref(from).processPlan.workorderDistributNum) + _toDisplayString(_unref(from).processPlan.unitName), 1)
          ])),
      _createElementVNode("div", _hoisted_6, [
        (!_unref(from).processPlan)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "请选择"))
          : _createCommentVNode("", true),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "bg_list_item_num",
            onClick: openDev
          }, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                  style: _normalizeStyle({color: _unref(from).deviceName ? '#333' : ''})
                }, _toDisplayString(_unref(from).deviceName ? _unref(from).deviceName : '请选择'), 5),
                _hoisted_16
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "bg_list_item_num",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(userShow) //@ts-ignore
 ? userShow.value = true : userShow = true))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", {
                  style: _normalizeStyle({color: _unref(from).userName ? '#333' : ''})
                }, _toDisplayString(_unref(from).userName ? _unref(from).userName : '请选择'), 5),
                _hoisted_20
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          ((_unref(hasBom) == 1 && _unref(bomType) != 1) || _unref(hasBom) == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "bg_list_item_top_right",
                onClick: openMaterial
              }, _hoisted_26))
            : _createCommentVNode("", true)
        ]),
        (_unref(wuList).length > 0 && !(_unref(hasBom) == 1 && _unref(bomType) == 1))
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(wuList), (item, index) => {
              return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
                right: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    style: {"height":"100%"},
                    onClick: ($event: any) => (deleItem(index)),
                    square: "",
                    text: "删除",
                    type: "danger"
                  }, null, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", null, _toDisplayString(item.materialName) + _toDisplayString(item.procedureName ? ` | ${item.procedureName}` : ''), 1),
                          _createElementVNode("div", _hoisted_31, [
                            (item.qualityType == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "合格 / "))
                              : _createCommentVNode("", true),
                            (item.qualityType == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "不良 / "))
                              : _createCommentVNode("", true),
                            (item.qualityType == 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, "报废 / "))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(item.locationName) + " / ", 1),
                            _createElementVNode("span", null, _toDisplayString(item.batch), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                            onInput: ($event: any) => (inputwl(index))
                          }, null, 40, _hoisted_36), [
                            [_vModelText, item.num]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(item.unitName), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_unref(wuList).length == 0 && !(_unref(hasBom) == 1 && _unref(bomType) == 1))
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
            : _createCommentVNode("", true),
        (_unref(hasBom) == 1 && _unref(bomType) == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(from).qualified) = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (changeNum(1))),
                  placeholder: "请输入"
                }, null, 544), [
                  [_vModelText, _unref(from).qualified]
                ]),
                (_unref(from).processPlan)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(from).processPlan.unitName), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(from).undesirable) = $event)),
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (changeNum(2))),
                  placeholder: "请输入"
                }, null, 544), [
                  [_vModelText, _unref(from).undesirable]
                ]),
                (_unref(from).processPlan)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_unref(from).processPlan.unitName), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_unref(from).undesirable > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", {
                  class: "bg_list_item_num_item",
                  onClick: openBL
                }, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("span", {
                      class: "wulll",
                      style: _normalizeStyle({color: _unref(from).defectiveName ? '#305ED5' : ''})
                    }, _toDisplayString(_unref(from).defectiveName ? _unref(from).defectiveName : '设置'), 5),
                    _hoisted_59
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "bg_plan",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(TimeShow) //@ts-ignore
 ? TimeShow.value = true : TimeShow = true))
      }, [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("span", {
            style: _normalizeStyle({color: _unref(from).durationName ? '#333' : ''})
          }, _toDisplayString(_unref(from).durationName ? _unref(from).durationName : '请选择'), 5),
          _hoisted_62
        ])
      ]),
      (_unref(arrType) && _unref(arrType).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _hoisted_64,
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("div", _hoisted_69, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(arrType), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(item.active ? 'bg_list_item_num_item_list_item active' : 'bg_list_item_num_item_list_item'),
                        key: index,
                        onClick: ($event: any) => (clickPerformanceType(index))
                      }, _toDisplayString(item.name), 11, _hoisted_70))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("span", _hoisted_75, _toDisplayString((_unref(arrType)[_unref(from).index].salary / 10 / 10).toFixed(2)) + "元/" + _toDisplayString(_unref(arrType)[_unref(from).index].type == 0 ? '件' : '时'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(expectedSalary)) + "元", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("span", _hoisted_85, _toDisplayString(_unref(complianceRate)) + "%", 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_86,
    _createElementVNode("div", { class: "bg_footer" }, [
      _createElementVNode("div", {
        class: "bg_footer_submit1",
        onClick: continueSubmit
      }, "继续报工"),
      _createElementVNode("div", {
        class: "bg_footer_submit",
        onClick: submit
      }, "提交")
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _hoisted_90,
            _createElementVNode("img", {
              src: _imports_2,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = false : show = false)),
              alt: ""
            })
          ]),
          _createElementVNode("div", _hoisted_91, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cateList), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bl_list_item",
                key: i,
                onClick: ($event: any) => (changeChecked(i))
              }, [
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: item.active
                  }, null, 8, _hoisted_94),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                    placeholder: "0"
                  }, null, 8, _hoisted_96), [
                    [_vModelText, item.num]
                  ])
                ])
              ], 8, _hoisted_92))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "bl_footer",
            onClick: onConfirm3
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(MaterialY, {
      show: _unref(show1),
      plansId: String(_unref(plansId)),
      ids: _unref(ids),
      deviceId: String(_unref(deviceId)),
      onClose: close,
      onValue: getValue
    }, null, 8, ["show", "plansId", "ids", "deviceId"]),
    _createVNode(_component_van_popup, {
      show: _unref(deviceShow),
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_isRef(deviceShow) ? (deviceShow).value = $event : deviceShow = $event)),
      round: "",
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _unref(deviceList),
          onConfirm: onConfirm,
          onCancel: onCancel,
          "columns-field-names": customFieldName
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(user, {
      show: _unref(userShow),
      onClose: onCancel1,
      onValue: onConfirm1
    }, null, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(TimeShow),
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_isRef(TimeShow) ? (TimeShow).value = $event : TimeShow = $event)),
      round: "",
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _unref(from).time,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(from).time) = $event)),
          type: "time",
          title: "选择时间",
          onConfirm: onConfirm2,
          onCancel: onCancel2
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})